import { makeStyles } from "@material-ui/core";
import { Colors } from "../../../helpers/theme";

const PartnerStakeStyle = makeStyles((theme) => ({
  root: {
    overflow: "auto",
    display: "flex",
    width: "100%",
    margin: "0px 0px 0px 0px",
  },
  container: {
    "&.MuiContainer-root": {
      // TODO: remove once Layouts/Templates are done properly
      "padding-right": "8px",
      "padding-left": "8px",
    },
  },
  cardRoot: {
    borderRadius: "15px",
    boxShadow: "0px 8px 28px 0px #4D92D512, 0px 4px 6px 0px #06092505",
  },
  cardContent: {
    borderRadius: "15px 15px 0 0",
    position: "relative",
    top: "-15px",
    background: Colors.white,
    padding: "15px 20px 0px 20px !important",
  },
  title: {
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "20px",
    color: Colors.greenDark,
  },
  description: {
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    marginTop: "5px",
    maxHeight: "70px",
    overflow: "hidden",
    color: Colors.greySlate,
  },
  detailContainer: {
    margin: "10px 0 10px 0",
    "& p": {
      color: Colors.blackLight,
      fontSize: "14px",
      fontWeight: 600,
    },
    "& .detailValue": {
      color: Colors.PeurtoRico,
      fontSize: "14px",
      fontWeight: 700,
    },
  },
  cardAction: {
    backgroundColor: Colors.white,
    justifyContent: "center",
    margin: "10px 0px 10px 0px",
  },
  cardActionButton: {
    backgroundColor: Colors.greenLight,
    width: "100%",
  },
  externalLinks: {
    color: Colors.greenLight,
    cursor: "pointer",
    "&>a": {
      color: Colors.greenLight,
    }
  },
  token: {
    color: Colors.greenLight,
  },
  stakeDetailContainer: {
    backgroundColor: Colors.aliceblue,
    opacity: 0.8,
    display: "block",
  },
  stakeDetailsFooter: {
    "padding-right": "8px",
    "padding-left": "8px",
    marginBottom: "10px",
    "& p": {
      color: Colors.blackLight,
      fontSize: "14px",
      fontWeight: 600,
    },
    "& .detailValue": {
      fontSize: "12px",
      fontWeight: 700,
    },
  },
  inputField: {
    marginBottom: theme.spacing(2),
  },
  inputLabel: {
    color: Colors.greySlate,
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "22px",
    minHeight: "50px",
    maxHeight: "50px",
    overflow: "hidden",
  },
  formControl: {
    display: 'flex',
  },
  buttons: {
    marginTop: theme.spacing(1),
    padding: 0,
  },
  buttonsGrid: {
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  cancelButton: {
    backgroundColor: theme.palette.grey[300],
    height: '40px',
  },
  approveButton: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    height: '40px',
  },
  note: {
    marginTop: theme.spacing(1),
    color: Colors.greySlate,
    fontSize: "12px",
    fontWeight: 700,
  },
}));

export default PartnerStakeStyle;
